import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    boxShadow: '0px 1px 4px rgba(0,0,0,0.04)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2)
    }
  } as SxProps,

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  cardTitle: {
    color: '#1F2937',
    fontSize: 15,
    fontWeight: 700,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  } as SxProps,

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    backgroundColor: '#F5F3FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  } as SxProps,

  avatarRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.75),
    padding: theme.spacing(2, 0),
    width: '100%'
  } as SxProps,

  avatarName: {
    color: '#1F2937',
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'left'
  } as SxProps,

  avatarEmail: {
    color: '#6B7280',
    fontSize: 13,
    textAlign: 'left'
  } as SxProps,

  divider: {
    height: 1,
    backgroundColor: '#F3F4F6',
    width: '100%'
  } as SxProps,

  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    width: '100%'
  } as SxProps,

  addrIconWrap: {
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '8px',
    backgroundColor: '#F0FDF4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(0.25)
  } as SxProps,

  infoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1
  } as SxProps,

  infoLabel: {
    color: '#9CA3AF',
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: 1,
    textTransform: 'uppercase',
    textAlign: 'left'
  } as SxProps,

  infoPrimary: {
    color: '#1F2937',
    fontSize: 14,
    fontWeight: 600,
    textAlign: 'left'
  } as SxProps,

  infoSecondary: {
    color: '#6B7280',
    fontSize: 13,
    textAlign: 'left'
  } as SxProps
}

export default styles
